import script from "./ProgramOverviewEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramOverviewEdit.vue?vue&type=script&setup=true&lang=js"

import "./ProgramOverviewEdit.vue?vue&type=style&index=0&id=1bda1698&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bda1698"]])

export default __exports__